import { FC, useContext, useMemo } from 'react';

import { createGQLDataContext } from 'utils/createDataContext';
import { useSSFBehaviors } from 'hooks';
import { AssignToAgencyTeamMemberFetchJanesQuery } from 'types/graphql';
import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { fetchTeamMembersQueryConfig } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/contexts/context.constants';
import { isUserAgencyAndAgencyLocationFilterForcedDisabledSelector } from 'store/selectors/featureFlagSelectors';
import { useSelector } from 'react-redux';
import { SSFBehaviorsContextType } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { getCurrentlySelectedLocation } from 'utils/getCurrentlySelectedLocation';

export const FetchAgencyTeamMembersDataContext = createGQLDataContext({});

export const FetchAgencyTeamMembersDataProvider: FC = ({ children }) => {
  const { data } = useShiftModalDataContext();
  const order = data?.order;
  const isUserAgencyAndAgencyLocationFilterForcedDisabled = useSelector(
    isUserAgencyAndAgencyLocationFilterForcedDisabledSelector,
  );

  const currentlySelectedLocation = getCurrentlySelectedLocation();
  const communityId = Number(currentlySelectedLocation?.value);

  const queryConfig = useMemo(
    () =>
      fetchTeamMembersQueryConfig({
        orderId: order.relayId,
        positionId: order.position.displayId,
        canB2bAssign: order.canB2bAssign,
        communityId: !isUserAgencyAndAgencyLocationFilterForcedDisabled ? [communityId!] : [],
        breakTime: order?.orderSchedule?.breakTime,
      }),
    [
      communityId,
      order.canB2bAssign,
      order.position.displayId,
      order.relayId,
      order?.orderSchedule?.breakTime,
      isUserAgencyAndAgencyLocationFilterForcedDisabled,
    ],
  );

  const [values, rest] = useSSFBehaviors<AssignToAgencyTeamMemberFetchJanesQuery>(queryConfig);

  return (
    <FetchAgencyTeamMembersDataContext.Provider value={{ values, ...rest }}>
      {children}
    </FetchAgencyTeamMembersDataContext.Provider>
  );
};

export const useFetchAgencyTeamMembersDataContext = (): SSFBehaviorsContextType<
  AssignToAgencyTeamMemberFetchJanesQuery & { totalCount: number }
> => useContext(FetchAgencyTeamMembersDataContext);
